module.exports = __webpack_public_path__ + "img/il-pelaporan-berhasil.9d1b083c.svg";